import React, { useState, useEffect } from "react";
import FormField from "../../../../components/forms/FormField/FormField";
import GeneralUploader from "../../../../components/forms/GeneralUploader/GeneralUploader";
import axios from "../../../../api/axios";
import { addCustomFontRoute, removeCustomFontRoute, uploadCustomAssetRoute } from "../../../../api/routes";
import DEBUG_LOGGER from "../../../../helpers/DebugLogger";
import { toast } from "react-toastify";
import { applyFontPreview, FontPreviewBlock, getCustomFontUrl } from "../../../../helpers/CustomFonts";
import { slideOutPanelControl } from "../SlideoutPanel";
import './CustomFontsContent.scss';

const CustomFontsContent = (props) => {
    const [newFontName, setNewFontName] = useState('');
    const [newFontNameError, setNewFontNameError] = useState('');
    const [newFontFileData, setNewFontFileData] = useState(null);
    const [newFileError, setNewFileError] = useState('');

    const [editCustomFontIndex, setEditCustomFontIndex] = useState(null);
    const [editingFontName, setEditingFontName] = useState('');
    const [editingFontNameError, setEditingFontNameError] = useState('');
    
    const [confirmRemoveFont, setConfirmRemoveFont] = useState(false);
    const [busy, setBusy] = useState(false);

    console.log('CustomFontsContent props: ', props);

    const addCustomFont = () => {
        let gotErrors = false;
        setNewFontNameError('');
        setNewFileError('');

        if (newFontName === '') {
            setNewFontNameError('Please enter a font name.');
            gotErrors = true;
        }
        if (!newFontFileData) {
            setNewFileError('Please select a font file.');
            gotErrors = true;
        } else {
            // Is the font file name already in use?
            const fileExists = props.customFonts.find(font => font.fontFilename === newFontFileData.file.name);
            if (fileExists) {
                setNewFileError('File already exists.');
                gotErrors = true;
            }
        }
        if (newFontName !== '' && newFontName.length > 50) {
            setNewFontNameError('Font name is too long.');
            gotErrors = true;
        } else {
            // is the font name already in use?
            const fontExists = props.customFonts.find(font => font.fontFamily === newFontName);
            if (fontExists) {
                setNewFontNameError('Font name already exists.');
                gotErrors = true;
            }
        }
        if (gotErrors) {
            return;
        }

        // Clear any existing errors since validation passed
        setNewFontNameError('');
        setNewFileError('');
        setBusy(true);

        // Upload the font file
        const formData = new FormData();
        formData.append('filename', newFontFileData.file.name);
        formData.append('campaignID', props.campaignId);
        formData.append('type', 'fonts');
        formData.append('file', newFontFileData.file);
        axios.post(uploadCustomAssetRoute, formData, { withCredentials: true })
                .then(res => {
                    console.log('Upload result: ', res);
                    const uploadedFilename = res.data.uploadedFilename;
                    // File successfully uploaded, now add the font to the list
                    axios.post(addCustomFontRoute, {
                        campaignID: props.campaignId,
                        fontFamily: newFontName,
                        fontFilename: uploadedFilename
                    }, { withCredentials: true })
                        .then(res => {
                            console.log('Add Font result: ', res);
                            toast.success('Font Added Successfully');
                            
                            const newFontData = {
                                fontFamily: newFontName,
                                fontFilename: uploadedFilename
                            };
                            if (props.fullCampaignData) {
                                if (!props.fullCampaignData.customFonts) {
                                    props.fullCampaignData.customFonts = [];
                                }
                                props.fullCampaignData.customFonts.push(newFontData);
                            }

                            // Reset form
                            setNewFontName('');
                            setNewFontFileData(null);
                            setBusy(false);
                        })
                        .catch(err => {
                            DEBUG_LOGGER.log('Add Font error: ', err);
                            toast.error('Error Adding Font - ' + err);
                            setBusy(false);
                        });
                })
                .catch(err => {
                    DEBUG_LOGGER.log('Upload error: ', err);
                    toast.error('Error Uploading File - ' + err);
                    setBusy(false);
                });
    }

    const editCustomFont = (index) => {
        setEditCustomFontIndex(index);
        const fontData = props.customFonts[index];
        applyFontPreview(fontData.fontFamily, getCustomFontUrl(fontData.fontFilename, props.campaignId), '.apply-edit-custom-font');
        setEditingFontName(fontData.fontFamily);
    }

    const closeEditCustomFont = () => {
        setEditCustomFontIndex(null);
        setEditingFontName('');
        setEditingFontNameError('');
        setNewFontFileData(null);
        setNewFileError('');
    }

    const applyFontChanges = () => {
        let gotErrors = false;
        setEditingFontNameError('');
        setNewFileError('');

        if (editingFontName === '') {
            setEditingFontNameError('Please enter a font name.');
            gotErrors = true;
        }
        if (newFontFileData) {
            // Is the font file name already in use?
            const fileExists = props.customFonts.find(font => font.fontFilename === newFontFileData.file.name);
            if (fileExists && newFontFileData.file.name !== props.customFonts[editCustomFontIndex].fontFilename) {
                setNewFileError('File already exists.');
                gotErrors = true;
            }
        }
        if (editingFontName !== '' && editingFontName.length > 50) {
            setEditingFontNameError('Font name is too long.');
            gotErrors = true;
        } else {
            // is the font name already in use?
            const fontExists = props.customFonts.find(font => font.fontFamily === editingFontName);
            if (fontExists && editingFontName !== props.customFonts[editCustomFontIndex].fontFamily) {
                setEditingFontNameError('Font name already exists.');
                gotErrors = true;
            }
        }
        if (gotErrors) {
            return;
        }

        setBusy(true);
        // Implementation continues...
        // For now just close the edit mode
        closeEditCustomFont();
        setBusy(false);
    }

    const removeFont = () => {
        setConfirmRemoveFont(true);
    }

    const cancelRemoveFont = () => {
        setConfirmRemoveFont(false);
    }

    const removeFontNow = () => {
        axios.post(removeCustomFontRoute, {
            campaignID: props.campaignId, fontIndex: editCustomFontIndex
        }, { withCredentials: true })
            .then(res => {
                console.log('Remove Font result: ', res);
                toast.success('Font Removed Successfully');
                
                if (props.fullCampaignData) {
                    if (!props.fullCampaignData.customFonts) {
                        props.fullCampaignData.customFonts = [];
                    }
                    props.fullCampaignData.customFonts.splice(editCustomFontIndex, 1);
                }

                setBusy(false);
                setEditCustomFontIndex(null);
                setConfirmRemoveFont(false);
            })
            .catch(err => {
                DEBUG_LOGGER.log('Remove Font error: ', err);
                toast.error('Error Removing Font - ' + err);
                setBusy(false);
            });
    }

    if (editCustomFontIndex !== null && confirmRemoveFont) {
        return (
            <div className="custom-fonts-content">
                <div className="confirm-remove">
                    <h3>Remove Font</h3>
                    <p>Are you sure you want to remove "{props.customFonts[editCustomFontIndex]?.fontFamily}"?</p>
                    <div className="custom-fonts-actions">
                        <button className="standard-button secondary" onClick={cancelRemoveFont}>Cancel</button>
                        <button className="standard-button danger" onClick={removeFontNow}>Remove Font</button>
                    </div>
                </div>
            </div>
        );
    }

    if (editCustomFontIndex !== null) {
        const fontData = props.customFonts[editCustomFontIndex];
        return (
            <div className="custom-fonts-content">
                <div className="edit-font-section">
                    <div className="edit-font-header">
                        <h3>Edit Custom Font</h3>
                        <button className="back-button" onClick={closeEditCustomFont}>← Back to List</button>
                    </div>
                    
                    <div className="current-font-preview">
                        <div className="font-name">{fontData.fontFamily}</div>
                        <div className="font-file light-text">{fontData.fontFilename}</div>
                        <FontPreviewBlock className="apply-edit-custom-font" />
                    </div>

                    <FormField
                        id="editFontName"
                        label="Font Name"
                        type="text"
                        value={editingFontName}
                        setFunc={(val) => setEditingFontName(val)}
                        placeholder="Enter font name"
                        error={editingFontNameError}
                        readonly={busy}
                    />

                    <div className="fl-column no-gap">
                        <GeneralUploader
                            label="Replace Font File (optional)"
                            showLabel={true}
                            uploadImmediately={false}
                            showRemoveOption={false}
                            id="editFontFile"
                            fileSelectedCallback={(fileObj) => setNewFontFileData(fileObj)}
                            acceptedFileTypes=".woff2, .ttf, .otf"
                            enabled={!busy}
                        />
                        <div className="error">{newFileError}</div>
                    </div>

                    <div className="custom-fonts-actions">
                        <button className="standard-button danger" onClick={removeFont}>Remove Font</button>
                        <button className={`standard-button ${busy ? 'disabled' : ''}`} onClick={busy ? null : applyFontChanges}>
                            {busy ? 'Updating...' : 'Update Font'}
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="custom-fonts-content">
            <div className="custom-fonts-section">
                <h3>Your Custom Fonts</h3>
                <div className="light-text">Custom fonts are added on a campaign level and will be available to other disruptors and features once added.</div>
                
                {!props.customFonts?.length && (
                    <div className="no-fonts-message">No custom fonts have been added yet.</div>
                )}
                
                {props.customFonts?.length > 0 && (
                    <div className="custom-fonts-list">
                        {props.customFonts.map((font, index) => (
                            <div key={index} className="custom-font-item" onClick={() => editCustomFont(index)}>
                                <div className="font-name">{font.fontFamily}</div>
                                <div className="font-file light-text">{font.fontFilename}</div>
                            </div>
                        ))}
                    </div>
                )}

                <hr />

                <h3>Add New Custom Font</h3>

                <div className="add-font-section">
                    <div className="light-text">This will add a custom font to the list of available fonts for customisable elements.</div>
                    <div className="light-text">We recommend using *.woff2 files, but you can also use *.ttf or *.otf.</div>

                    <FormField
                        id="newFontName"
                        label="Font Name"
                        labelNote="This is the name that will be used to select the font in the editor and cannot be changed once added."
                        type="text"
                        value={newFontName}
                        setFunc={(val) => setNewFontName(val)}
                        placeholder="Enter font name"
                        error={newFontNameError}
                        readonly={busy}
                    />
                    
                    <div className="fl-column no-gap">
                        <GeneralUploader
                            label="Font File"
                            showLabel={false}
                            uploadImmediately={false}
                            showRemoveOption={false}
                            id="newFontFile"
                            fileSelectedCallback={(fileObj) => {
                                console.log('File selected: ', fileObj);
                                setNewFontFileData(fileObj);
                            }}
                            acceptedFileTypes=".woff2, .ttf, .otf"
                            enabled={!busy}
                        />
                        <div className="error">{newFileError}</div>
                    </div>

                    <div className="custom-fonts-actions">
                        <button 
                            className={`standard-button ${(!newFontName || !newFontFileData) ? 'disabled' : ''} ${busy ? 'disabled' : ''}`} 
                            onClick={busy || !newFontName || !newFontFileData ? null : addCustomFont}
                            disabled={busy || !newFontName || !newFontFileData}
                        >
                            {busy ? 'Adding Font. Please Wait...' : 'Add Custom Font'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CustomFontsContent;